import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useIsMobile(breakpointPx = 768) {
    const isMobile = ref(false);
    let mediaQuery = MediaQueryList;

    const update = () => {
        isMobile.value = window.innerWidth < breakpointPx;
    };

    onMounted(() => {
        mediaQuery = window.matchMedia(`(max-width: ${breakpointPx - 1}px)`);
        isMobile.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', update);
    });

    onBeforeUnmount(() => {
        mediaQuery?.removeEventListener('change', update);
    });

    return {
        isMobile,
    };
}
